export default __webpack_public_path__ + "static/media/940.649cf568.gif";